import { connect } from 'react-redux';
import invariant from 'invariant';
import get from 'lodash/get';
import { isUuid } from '../../../js/app/react/validators';
import View from './HealthcareWorkflowView';
import { WORKFLOW_ID } from './HealthcareWorkflowConstants';
import {
  reloadAdvizrApplication,
  endOfWorkflowsRedirectTo,
} from '../AdvWorkflow/AdvWorkflowHelpers';
import { shouldSkipSummarySelector } from '../AdvWorkflow/AdvWorkflowSelector';
import { getGoalPageName } from '../../FinancialPlanOPL/Goals/utils/getGoalPageName';
import { GoalTypeDTO } from '../../FinancialPlanOPL/types/goalsDTO';

const mapStateToProps = (state, ownProps) => ({
  workflowId: WORKFLOW_ID,
  shouldSkipSummary: shouldSkipSummarySelector(state, ownProps),
});

const mapDispatchToProps = () => ({
  outputFunction: clientId => response => {
    const { ADV } = window;
    reloadAdvizrApplication(true, false, () => {
      const currentClient = ADV.util.getCurrentClient(ADV.data);

      const outputRoute = currentClient.ComponentName || getGoalPageName(GoalTypeDTO.HealthCare);

      const goalId = get(response, 'payload.viewData.Goal.Id', null);
      invariant(isUuid(goalId), "'payload.viewData.Goal.Id' must be an uuid.");

      const params = {
        clientId,
        goalId,
      };
      endOfWorkflowsRedirectTo(outputRoute, params);
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
